/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteSet.defs.js'
export { main as default } from './deleteSet.defs.js'
